module.exports = __webpack_public_path__ + "static/media/Home_Products_08.a04e2424.png";